import routePaths from 'config/routes';
import { isConPlatform } from 'utils';

export const shouldRenderBreadCrumb = (pathname: string) => {
  const notRenderList = [
    routePaths.PAGES.EXPERIENCE,
    routePaths.PAGES.CHALLENGE,
    routePaths.PAGES.FORMATION,
  ];

  return !(isConPlatform && notRenderList.includes(pathname));
};

export const shouldRenderConBreadCrumb = (pathname: string) => {
  if (
    isConPlatform &&
    [
      routePaths.PAGES.EXPERIENCE_DETAIL,
      routePaths.PAGES.CHALLENGE_DETAIL,
      routePaths.PAGES.CHALLENGE,
      routePaths.PAGES.EXPERIENCE,
    ].includes(pathname)
  )
    return true;
  return false;
};
